
/** 
*@author: Sirisha.M
*@Description : This component is mainly for showing all the tabs of Failure Reporting
**/

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Tabs,
} from 'antd';
import {
  getRolesPermissionsList,
} from './ChartCalls';
import localStorage from '../../../utils/localStorage';
import { StyledHomepage } from '../../../commons/styles/layout';
import FailureReportingAndAssignment from './FailureReportingAndAssignment';
import AnalysisAndCorrectiveActions from './AnalysisAndCorrectiveActions';
import ManagerActions from './ManagerActions';
const { TabPane } = Tabs;
const FailureReports = (props) => {
  const [parentPresentActiveKey, setParentPresentActiveKey] = useState('Reporting');
  const [presentActiveKey, setPresentActiveKey] = useState('List');

  const [selectedRolesList, setSelectedRolesList] = useState([]);
  const [checkedValue, setCheckedValue] = useState(null);
  const [current, setCurrent] = useState(1);


  useEffect(() => {
    const fetchData = async () => {

      const roleId = JSON.parse(localStorage.get('roleId'));
      let selectedRolesList = await getRolesPermissionsList(roleId);

      let RolesData = selectedRolesList &&
        selectedRolesList.RolesAndPermissions &&
        selectedRolesList.RolesAndPermissions[0] &&
        selectedRolesList.RolesAndPermissions[0].permissions;
      setSelectedRolesList(RolesData);

      let activeKey = RolesData && RolesData[0] && RolesData[0].key;

      setParentPresentActiveKey(activeKey);

    };
    fetchData();
  }, []);


  const handleTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  const onActiveTabChange = (tab) => {
    setPresentActiveKey(tab);
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  return (
    <StyledHomepage >
      <Tabs
        defaultActiveKey={selectedRolesList && selectedRolesList[0] && selectedRolesList[0].key}
        activeKey={parentPresentActiveKey}
        onChange={async (activeKey) => {
          setParentPresentActiveKey(activeKey);
          setPresentActiveKey('List');
          setCurrent(1);
          setCheckedValue(null);
        }}
        type="card"
        bordered
      >

        {selectedRolesList && Array.isArray(selectedRolesList) && selectedRolesList.map(role => (
          <>
            <TabPane tab={translation(role.value)} key={role.key}>
              {role && role.key === "Failure Reporting And Assignment(user)" && (
                <FailureReportingAndAssignment
                  screenName={role.value}
                  current={current}
                  checkedValue={checkedValue}
                  handleTableChange={handleTableChange}
                  presentActiveKey={presentActiveKey}
                  onActiveTabChange={onActiveTabChange}
                />

              )}
              {role && role.key === "Analysis and Corrective Actions" && (
                <AnalysisAndCorrectiveActions
                  screenName={role.key}
                  current={current}
                  checkedValue={checkedValue}
                  handleTableChange={handleTableChange}
                  presentActiveKey={presentActiveKey}
                  onActiveTabChange={onActiveTabChange} />
              )}
              {role && role.key === "Failure Reporting And Assignment(manager)" && (
                <ManagerActions
                  screenName={role.value}
                  current={current}
                  checkedValue={checkedValue}
                  handleTableChange={handleTableChange}
                  presentActiveKey={presentActiveKey}
                  onActiveTabChange={onActiveTabChange} />
              )}
            </TabPane>
          </>

        ))}
      </Tabs>

    </StyledHomepage>
  );
};


const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    themeValue: state.ThemeReducer,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
    UserDetails: state.LayoutReducer.UserDetails,
  };
};
export default connect(mapStateToProps)(FailureReports);